import { tns } from 'tiny-slider';

(function (Drupal, once) {

  Drupal.behaviors.lifewatchGallery = {
    attach: function (context, settings) {
      const elements = once('sSliderEls', '.field--name-field-gallery-items', context);

      // node queue field
      elements.forEach((el) => {
        new tns({
          container: el.querySelector('div:first-child'),
          items: 1,
          slideBy: "page",
          autoplay: true,
          autoplayButtonOutput: false,
          nav: false,
          controlsText: ['', ''],
          controlsPosition: 'bottom'
        });
      });
    }
  }

}(Drupal, once));
